import { Controller } from "@hotwired/stimulus"

// Toggles overlay expansion on tap/click for mobile and accessibility
// Usage: data-controller="testimonial-overlay" on the .testimonial-card
// Targets: data-testimonial-overlay-target="overlay"
export default class extends Controller {
  static targets = ["overlay"]

  connect() {
    // Close when clicking outside the card (on mobile)
    this._onDocumentClick = (e) => {
      if (!this.element.contains(e.target)) {
        this.element.classList.remove("expanded")
      }
    }
    document.addEventListener("click", this._onDocumentClick)
  }

  disconnect() {
    document.removeEventListener("click", this._onDocumentClick)
  }

  toggle(event) {
    // Prevent Splide slide click from triggering unwanted navigation
    event.stopPropagation()
    this.element.classList.toggle("expanded")
  }
}
